import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { settings } from '../../settings/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  private appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: settings.appInsightsConnectionString,
        enableAutoRouteTracking: true
      }
    });
    this.appInsights.loadAppInsights();
  }

  trackPageView(name?: string, uri?: string): void {
    this.appInsights.trackPageView({ name, uri });
  }

  trackEvent(name: string, properties?: { [key: string]: any }): void {
    this.appInsights.trackEvent({ name }, properties);
  }

  trackException(error: Error): void {
    this.appInsights.trackException({ exception: error });
  }
}
